import { CatalogType } from '../../models/catalogs.models'

import PageCatalogList from '../../components/page/CatalogList.page'
import { FilterableRoute } from '../../models/commons.models'
const WorkspaceConstructionsPage = () => {
  return (
    <PageCatalogList
      withTabs
      withGroups
      types={[CatalogType.construction]}
      filterKey={FilterableRoute.workspaceConstructions}
    />
  )
}
export default WorkspaceConstructionsPage
